const findNextCardAfterDeletion = (deletedId, sections, isSection = false) => {
  let foundItem = false
  let prevCard = null
  for (let sectionIndex = 0; sectionIndex < sections.length; sectionIndex++) {
    const section = sections[sectionIndex]
    if (!section?.cards?.length) continue

    if (isSection && section.id === deletedId) {
      foundItem = true
      // Look for cards in next sections
      for (let j = sectionIndex + 1; j < sections.length; j++) {
        if (sections[j]?.cards?.length) {
          return sections[j].cards[0]
        }
      }
      // If no next card found, return the previous card
      return prevCard
    }

    // Original card deletion logic
    for (let i = 0; i < section.cards.length; i++) {
      const currentCard = section.cards[i]

      if (!isSection && currentCard.id === deletedId) {
        foundItem = true
        // Check if there's a next card in the same section
        if (i + 1 < section.cards.length) {
          return section.cards[i + 1]
        }

        // If no next card in current section, look in next sections
        for (let j = sectionIndex + 1; j < sections.length; j++) {
          if (sections[j]?.cards?.length) {
            return sections[j].cards[0]
          }
        }

        // If no next card found, return the previous card
        return prevCard
      }

      prevCard = currentCard
    }
  }

  return null
}

export default findNextCardAfterDeletion
